function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

import { from } from "../../theme";

var compareFn = function compareFn(a, b) {
  if (a[1] === b[1]) return 0;
  return a[1] < b[1] ? -1 : 1;
};

export var getValuesWithMediaQueries = function getValuesWithMediaQueries(theme, values) {
  var entries = Object.entries(theme.variables.breakpoints).sort(compareFn);
  var mediaQueries = [null].concat(_toConsumableArray(entries.map(function (entry) {
    return entry[0];
  }))).map(function (key) {
    return from(key)({
      theme: theme
    });
  });
  return values.map(function (value, index) {
    return [mediaQueries[index], value];
  });
};